import React, { useContext, useState } from "react";
const ScrollableComponent = (props) => {
    
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [startY, setStartY] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const [scrollTop, setScrollTop] = useState(0);

    const myElement = props.elementRef

    const handleMouseDown = (e) => {
        if (e.button !== 2) return; // Right-click only
        e.preventDefault();
        setIsDragging(true);
        const parent = myElement[0];
        setStartX(e.pageX);
        setStartY(e.pageY);
        setScrollLeft(parent.scrollLeft);
        setScrollTop(parent.scrollTop);
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const parent = myElement[0];
        const x = e.pageX - startX;
        const y = e.pageY - startY;
        parent.scrollLeft = scrollLeft - x;
        parent.scrollTop = scrollTop - y;
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    return (
        <div
            className="parent-scrollable-component"
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp} 
            onContextMenu={(e) => e.preventDefault()}
        >
            {props.children}
        </div>
    );
};

export default ScrollableComponent;
